var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{class:("fa font_lg\t" + (_vm.realIcon.iconName) + " " + (_vm.realIcon.colorName))}),(_vm.realText)?_c('span',{staticClass:"margin_l_5"},[_c('b',[_vm._v(_vm._s(_vm.realText))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }